import React from 'react';
import SiteFooter from '../components/SiteFooter';

export default function Partners() {
  return (
    <div style={{background:'#F6F4EF', minHeight:'100vh'}}>
      <div style={{maxWidth:900, margin:'0 auto', padding:'24px 16px'}}>
        <h1>Стати партнером (кавʼярнею)</h1>
        <p style={{lineHeight:1.7}}>
          Приєднуйтесь до Книгообігу та залучайте нових гостей. Ми надаємо просту панель баристи,
          плакати, наліпки та консультації зі старту. Вам потрібна лише полиця для книг і бажання
          підтримати локальну спільноту читачів.
        </p>
        <h3>Що отримає кавʼярня</h3>
        <ul>
          <li>Нових відвідувачів та повторні візити за книгами.</li>
          <li>Промоматеріали та згадку на мапі партнерів.</li>
          <li>Просту систему обліку: прийом/видача в кілька кліків.</li>
        </ul>
        <h3>Як підключитися</h3>
        <ol>
          <li>Напишіть нам на <a href="mailto:knyhoobih@gmail.com">knyhoobih@gmail.com</a> з темою «Партнерство».</li>
          <li>Підтвердимо адресу й погодимо стартові матеріали.</li>
          <li>Отримаєте доступ до панелі баристи та інструкцій.</li>
        </ol>
      </div>
      <SiteFooter />
    </div>
  );
}

